import { render, staticRenderFns } from "./TechDiagnosis.vue?vue&type=template&id=4f776328&scoped=true"
import script from "./TechDiagnosis.vue?vue&type=script&lang=js"
export * from "./TechDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./TechDiagnosis.vue?vue&type=style&index=0&id=4f776328&prod&scoped=true&lang=css"
import style1 from "./TechDiagnosis.vue?vue&type=style&index=1&id=4f776328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f776328",
  null
  
)

export default component.exports